const Reducer = (state, action) => {
  switch (action.type) {
    case REDUCER_ACTION_TYPES.SET_NEW_SCORES:
      return {
        ...state,
        newScores: action.payload,
      };
    case REDUCER_ACTION_TYPES.CHANGE_BUDGET_ORDER:
      return {
        ...state,
        budgetOrder: action.payload,
      };
    case REDUCER_ACTION_TYPES.SET_GENERATED_DOCUMENTS:
      if (state.generatedDocuments && action.payload) {
        state.generatedDocuments = action.payload.map((document, index) => {
          if (!state.generatedDocuments[index]) return { ...document };

          return { ...state.generatedDocuments[index], ...document };
        });
      } else state.generatedDocuments = action.payload;
      return {
        ...state,
        generatedDocuments: state.generatedDocuments,
      };
    case REDUCER_ACTION_TYPES.GENERATING_DOCUMENT:
      return {
        ...state,
        generatingDocument: action.payload,
      };
    case REDUCER_ACTION_TYPES.TOGGLE_THEME:
      return {
        ...state,
        theme: action.payload,
      };
    case REDUCER_ACTION_TYPES.TOGGLE_NAV_DRAWER:
      return {
        ...state,
        navDrawerOpen: action.payload,
      };
    case REDUCER_ACTION_TYPES.KEEP_BUDGET_ACCESS_FOR_USERS_ACTIVE:
      return {
        ...state,
        keepBudgetAccessForUsersActive: action.payload,
      };
    case REDUCER_ACTION_TYPES.SAVE_UNSAVED_CHANGES:
      return {
        ...state,
        saveUnsavedChanges: action.payload,
      };
    case REDUCER_ACTION_TYPES.FIRE_UNSAVED_CHANGES_DIALOG:
      return {
        ...state,
        fireUnsavedChangesDialog: action.payload,
      };
    case REDUCER_ACTION_TYPES.DISCARD_UNSAVED_CHANGES:
      return {
        ...state,
        discardUnsavedChanges: action.payload,
      };
    case REDUCER_ACTION_TYPES.SET_USER_NAVIGATED:
      return {
        ...state,
        userNavigated: action.payload,
      };
    case REDUCER_ACTION_TYPES.SET_DISABLED_UNSAVED_CHANGES_DIALOG_SAVE_BUTTON:
      return {
        ...state,
        disabledUnsavedChangesDialogSaveButton: action.payload,
      };
    case REDUCER_ACTION_TYPES.SET_TRIGGER_SAVE:
      return {
        ...state,
        triggerSave: action.payload,
      };
    case REDUCER_ACTION_TYPES.SET_TRIGGER_DISCARD:
      return {
        ...state,
        triggerDiscard: action.payload,
      };
    case REDUCER_ACTION_TYPES.SET_ACTIVE_BUDGET_LOADING_TRIGGER:
      return {
        ...state,
        activeBudgetLoadingTrigger: action.payload,
      };
    case REDUCER_ACTION_TYPES.REFRESH_DRAWER_HARD:
      return {
        ...state,
        refreshDrawerHard: action.payload,
      };
    case REDUCER_ACTION_TYPES.REFRESH_REQUESTS:
      return {
        ...state,
        refreshRequests: action.payload,
      };
    case REDUCER_ACTION_TYPES.REFRESH_GROUPS:
      return {
        ...state,
        refreshGroups: action.payload,
      };
    case REDUCER_ACTION_TYPES.REFRESH_ORGANIZATION_ACCESS:
      return {
        ...state,
        refreshOrganizationAccess: action.payload,
      };
    case REDUCER_ACTION_TYPES.SET_GOALS_PROGRESS:
      return {
        ...state,
        goalsProgress: action.payload,
      };
    case REDUCER_ACTION_TYPES.SET_INSIGHT_DATA:
      return {
        ...state,
        insightData: action.payload,
      };
    case REDUCER_ACTION_TYPES.SET_SESSION_CHECKED:
      return {
        ...state,
        sessionChecked: action.payload,
      };
    case REDUCER_ACTION_TYPES.BACK_BUTTON_FIRED:
      return {
        ...state,
        backButtonFired: action.payload,
      };
    case REDUCER_ACTION_TYPES.CHANGES_WERE_MADE:
      return {
        ...state,
        changesWereMade: action.payload,
      };
    case REDUCER_ACTION_TYPES.IS_DIRTY: 
      return {
        ...state,
        isDirty: action.payload,
      };
    case REDUCER_ACTION_TYPES.DOWNLOAD:
      return {
        ...state,
        download: action.payload,
      };
    case REDUCER_ACTION_TYPES.SET_BUDGET_SUCCESSFULLY_UPLOADED:
      return {
        ...state,
        budgetSuccessfullyUploaded: action.payload,
      };
    case REDUCER_ACTION_TYPES.ORGANIZATION_ACCESS:
      return {
        ...state,
        organizationAccess: action.payload,
      };
    case REDUCER_ACTION_TYPES.SET_PROGRAM_COUNT_FOR_ACTIVE_BUDGET:
      return {
        ...state,
        programCountForActiveBudget: action.payload
      };
    default:
      return state;
  }
};

export default Reducer;

export const REDUCER_ACTION_TYPES = {
  KEEP_BUDGET_ACCESS_FOR_USERS_ACTIVE: 'KEEP_BUDGET_ACCESS_FOR_USERS_ACTIVE',
  REFRESH_REQUESTS: 'REFRESH_REQUESTS',
  REFRESH_GROUPS: 'REFRESH_GROUPS',
  REFRESH_DRAWER_HARD: 'REFRESH_DRAWER_HARD', // 🍆
  SET_USER_NAVIGATED: 'SET_USER_NAVIGATED',
  FIRE_UNSAVED_CHANGES_DIALOG: 'FIRE_UNSAVED_CHANGES_DIALOG',
  SAVE_UNSAVED_CHANGES: 'SAVE_UNSAVED_CHANGES',
  DISCARD_UNSAVED_CHANGES: 'DISCARD_UNSAVED_CHANGES',
  IS_DIRTY: 'IS_DIRTY',
  SET_NEW_SCORES: 'SET_NEW_SCORES',
  CHANGE_BUDGET_ORDER: 'CHANGE_BUDGET_ORDER',
  SET_GENERATED_DOCUMENTS: 'SET_GENERATED_DOCUMENTS',
  GENERATING_DOCUMENT: 'GENERATING_DOCUMENT',
  TOGGLE_THEME: 'TOGGLE_THEME',
  TOGGLE_NAV_DRAWER: 'TOGGLE_NAV_DRAWER',
  SET_LOADER_MESSAGE: 'SET_LOADER_MESSAGE',
  SET_DISABLED_UNSAVED_CHANGES_DIALOG_SAVE_BUTTON: 'SET_DISABLED_UNSAVED_CHANGES_DIALOG_SAVE_BUTTON',
  SET_TRIGGER_SAVE: 'SET_TRIGGER_SAVE',
  SET_TRIGGER_DISCARD: 'SET_TRIGGER_DISCARD',
  SET_ACTIVE_BUDGET_LOADING_TRIGGER: 'SET_ACTIVE_BUDGET_LOADING_TRIGGER',
  REFRESH_ORGANIZATION_ACCESS: 'REFRESH_ORGANIZATION_ACCESS',
  SET_GOALS_PROGRESS: 'SET_GOALS_PROGRESS',
  SET_INSIGHT_DATA: 'SET_INSIGHT_DATA',
  SET_SESSION_CHECKED: 'SET_SESSION_CHECKED',
  BACK_BUTTON_FIRED: 'BACK_BUTTON_FIRED',
  CHANGES_WERE_MADE: 'CHANGES_WERE_MADE',
  DOWNLOAD: 'DOWNLOAD',
  SET_BUDGET_SUCCESSFULLY_UPLOADED: 'SET_BUDGET_SUCCESSFULLY_UPLOADED',
  ORGANIZATION_ACCESS: 'ORGANIZATION_ACCESS',
  SET_PROGRAM_COUNT_FOR_ACTIVE_BUDGET: 'SET_PROGRAM_COUNT_FOR_ACTIVE_BUDGET',
};
